/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, Fragment } from 'react';
import PrimaryTable from "../../../../../Shared/components/PrimaryTable";
import { StoreSalesLine } from "../../../../../../config/constant";
import { TableCell, TableRow, TextField, InputAdornment, Checkbox } from "@mui/material";
import clsx from 'clsx';
import AddButon from "../../../../../../assets/images/AddButon.svg";
import SubtractButton from "../../../../../../assets/images/SubtractButton.svg";
import SelectedIcon from "../../../../../../assets/images/SelectedIcon.svg";
import { Image } from "antd";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import ElipsisIcon from "../../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { currencyFormat, idNamingConversion } from "../../../../../../helpers/utilities";
import { NavLink } from "react-router-dom";
import { Dropdown, Menu, Space } from "antd";
import { LineRow } from './LineRow';


export const LineTable = (props) => {
    const { selected, classes, form, handleCheckBoxClick, returnProducts, viewType, lineForm, changeHandlerLineFocus, units,
        changeHandlerLine, customObject, salesType, onDelete, onView, handleQuantityChange, headerView, clickProductId, parameterDetails, unitMesurementdetails } = props;

    useEffect(() => {
        if (clickProductId && document.getElementById("tableRow_" + clickProductId)) {
            if (viewType === 'tile') {
                setTimeout(() => {
                    var doc = document.getElementById("tableRow_" + clickProductId);
                    doc.querySelector(`.${classes.storeSalesLineQuantityInput}`).focus();
                    doc.querySelector(`.${classes.storeSalesLineQuantityInput}`).select();
                });
            }
        }
    }, [clickProductId]);



    const isSelected = (name) => {
        const result = returnProducts.indexOf(name) !== -1;
        return result;
    }

    const handleClick = (id) => {
        const selectedIndex = returnProducts.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(returnProducts, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(returnProducts.slice(1));
        } else if (selectedIndex === returnProducts?.length - 1) {
            newSelected = newSelected.concat(returnProducts.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                returnProducts.slice(0, selectedIndex),
                returnProducts.slice(selectedIndex + 1),
            );
        }
        handleCheckBoxClick(newSelected);
    };


    return (
        <>
            <PrimaryTable
                heads={StoreSalesLine}
                component={
                    <>
                        {
                            selected?.length > 0 ? selected.map((data, i) => (
                                <Fragment key={i}>
                                    <TableRow id={'tableRow_' + data.productId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative, { [classes.selectedLineView]: ((data.productId === lineForm.productId) || (!lineForm.productId && i === 0)) }, { [classes.withOutGst]: data?.includeGst && !data?.productGstId })}>
                                        <TableCell style={{ width: 55 }}>
                                            {
                                                ((data.productId === lineForm.productId) || (!lineForm.productId && i === 0)) ? <span style={{ display: "inline-block", verticalAlign: "middle" }} className={classes.selectedIconView}><img src={SelectedIcon} alt={data.description} /></span> : <span style={{ display: "inline-block", verticalAlign: "middle", opacity: 0 }} className={classes.selectedIconView}><img src={SelectedIcon} alt={data.description} /></span>
                                            }
                                            <span style={{ display: "inline-block", verticalAlign: "middle" }}>{i + 1}</span>
                                        </TableCell>
                                        <TableCell><NavLink to={"#"} id={idNamingConversion('View_' + i, 'storeSalesLine', 'Link')} className={clsx(classes.bold, classes.color)}
                                            onClick={() => onView(data, i)}><span className={classes.descEllipsis}>{data.description}</span></NavLink></TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                            <div className={classes.stroeQuantity}>
                                                {
                                                    (headerView || form?.isReturnWithReceipt) ? data?.quantity : <>
                                                        <Image id={idNamingConversion('Quantity_Minus_' + i, 'storeSalesLine', 'Icon')} onClick={() => handleQuantityChange(data, 'decrease')} src={SubtractButton} preview={false} />
                                                        <TextField autoComplete='one-time-code'
                                                            fullWidth
                                                            className={clsx(classes.storeSalesLineQuantity)}
                                                            value={data?.quantity}
                                                            type={'number'}
                                                            InputProps={{
                                                                classes: {
                                                                    input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                }
                                                            }}
                                                            InputLabelProps={{
                                                                className: classes.textAreaLableColorCustom,
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onKeyDown={(e) => {
                                                                // if (e.keyCode === 40 || e.keyCode === 38) {
                                                                //     e.preventDefault();
                                                                //     return false
                                                                // }
                                                            }}
                                                            id={idNamingConversion('Quantity_' + i, 'storeSalesLine', 'TextField')}
                                                            onWheel={(e) => e.target.blur()}
                                                            onFocus={(e) => { e.target.select(); changeHandlerLineFocus(data) }}
                                                            onChange={(e) => {
                                                                if (e.target.value !== '') {
                                                                    if (salesType === 'Sale' && e.target.value < 0) {
                                                                        changeHandlerLine(data, e.target.value = 0, 'quantity');
                                                                    } else if (salesType === 'Sale Return' && e.target.value >= 0) {
                                                                        changeHandlerLine(data, -(e.target.value), 'quantity');
                                                                    } else {
                                                                        changeHandlerLine(data, e.target.value, 'quantity')
                                                                    }
                                                                } else {
                                                                    changeHandlerLine(data, e.target.value, 'quantity')
                                                                }
                                                            }}
                                                        /> <Image id={idNamingConversion('Quantity_Plus_' + i, 'storeSalesLine', 'Icon')} onClick={() => handleQuantityChange(data, 'increase')} src={AddButon} preview={false} />
                                                    </>
                                                }
                                            </div>
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.storeSalesLineUnit, classes.textAlignCenter)}>
                                       
                                            {
                                                (headerView || form?.isReturnWithReceipt) ? data?.unit?.name :
                                                    <AutoCompleteComponent
                                                        customLabel={"Unit"}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }, { 'key': 'description', 'name': 'Description' }]}
                                                        details={parameterDetails?.inventoryTransaction ? units[data?.productId] : unitMesurementdetails}
                                                        parentValue={customObject(parameterDetails?.inventoryTransaction ? units[data?.productId] : unitMesurementdetails, data?.unitId)}
                                                        position={"bottom"}
                                                        variant={'outlined'}
                                                        orginPosVet={30}
                                                        orginPosHor={-100}
                                                        id={idNamingConversion('Unit_' + i, 'storeSalesLine', 'DropDown')}
                                                        onChange={(d) => changeHandlerLine(data, d, 'unitId', 'unit')}
                                                    />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignRight)}>
                                            {
                                                (headerView || form?.isReturnWithReceipt) ? data.pricePerUnit :
                                                    <TextField autoComplete='one-time-code'
                                                        fullWidth
                                                        type={'number'}
                                                        className={clsx(classes.storeSalesLineQuantity, classes.storeSalesLinePrice)}
                                                        value={data.pricePerUnit}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            },
                                                        }}
                                                        id={idNamingConversion('Unit Price_' + i, 'storeSalesLine', 'DropDown')}
                                                        onWheel={(e) => e.target.blur()}
                                                        InputLabelProps={{ className: classes.textAreaLableColorCustom }}
                                                        onFocus={(e) => { e.target.select(); changeHandlerLineFocus(data) }}
                                                        onChange={(e) =>
                                                            e.target.value !== '' ?
                                                                e.target.value < 0 ?
                                                                    changeHandlerLine(data, e.target.value = 0, 'pricePerUnit') :
                                                                    changeHandlerLine(data, parseFloat(e.target.value), 'pricePerUnit') : changeHandlerLine(data, parseFloat(e.target.value), 'pricePerUnit')}
                                                    />
                                            }
                                        </TableCell>
                                        <TableCell className={classes.textAlignRight}><span style={{ display: "inline-block", verticalAlign: "middle", lineHeight: 1 }}>{'₹ ' + currencyFormat(data.netAmount)}</span> {(data.discountPercentage || data.discountAmount) ? <span className={classes.appliedDiscount}>D</span> : ''}</TableCell>
                                        <TableCell>
                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                {
                                                    form?.isReturnWithReceipt &&
                                                    <Checkbox tabIndex={-1} onClick={() => { !headerView && handleClick(data.id) }} color="primary" disabled={data?.isReturned} checked={isSelected(data.id)} />
                                                }
                                                {
                                                    !headerView && <>
                                                        <NavLink to={"#"} id={idNamingConversion('Delete_' + i, 'storeSalesLine', 'Icon')} tabIndex={-1} className={clsx({ [classes.disabled]: form?.isReturnWithReceipt })} onClick={() => onDelete(data?.productId)}>
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                        <Dropdown
                                                            tabIndex={-1}
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item key={"Arrow"} className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    <Menu.Item key={"Confirm"}><NavLink id={idNamingConversion('View_' + i, 'storeSalesLine', 'Link')} to={'#'} onClick={() => onView(data, i)}>View</NavLink></Menu.Item>
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + i, 'storeSalesLine', 'Icon')}
                                                                src={ElipsisIcon} preview={false} />
                                                        </Dropdown>
                                                    </>
                                                }
                                            </Space>
                                        </TableCell>
                                    </TableRow>
                                    {/* {
                                    data?.includeGst && !data?.productGstId &&
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell style={{ width: 55 }}></TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.storeSalesLineUnit, classes.storeSalesLineProduct)} style={{ width: 200 }}>
                                            <AutoCompleteComponent
                                                customLabel={["Product GST Code"]}
                                                heads={[{ 'key': 'code', 'name': 'Product GST Code' },
                                                { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }]}
                                                details={productGstdetails}
                                                parentValue={customObject(productGstdetails, data?.productGstId)}
                                                onChange={(d) => changeLineProductGst(i, { ...data, 'productGst': d, 'productGstId': d.id })}
                                                position={"top"}
                                                variant={'outlined'}
                                                topPosition={true}
                                            />
                                        </TableCell>
                                        <TableCell colSpan={5}> </TableCell>
                                    </TableRow>
                                } */}
                                </Fragment>
                            )) :
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ textAlign: "center" }} colSpan={7}>Start By adding Product</TableCell>
                                </TableRow>
                        }
                    </>
                }
                extraTable={
                    (headerView || form?.isReturnWithReceipt) ? <></> : <LineRow  {...props} />
                }
            />
        </>
    )
}